/**
 * Scroll Reveal Steps
 * Reveals steps as they come into viewport during scrolling
 */

class ScrollRevealSteps {
  constructor() {
    this.items = document.querySelectorAll('.scroll-reveal-steps__item');
    this.options = {
      threshold: 0.1, // Trigger when 10% of element is visible (better for 100vh elements)
      rootMargin: '0px 0px -10% 0px' // Trigger when element is 10% into viewport
    };
    
    this.init();
  }
  
  init() {
    if (!this.items.length) return;
    
    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
      this.createObserver();
    } else {
      // Fallback for older browsers
      this.fallbackReveal();
    }
  }
  
  createObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.revealItem(entry.target);
        }
      });
    }, this.options);
    
    // Observe all items
    this.items.forEach(item => {
      this.observer.observe(item);
    });
  }
  
  revealItem(item) {
    // Add revealed class immediately for 100vh elements
    item.classList.add('revealed');
    
    // Stop observing once revealed (one-time animation)
    if (this.observer) {
      this.observer.unobserve(item);
    }
  }
  
  fallbackReveal() {
    // Simple fallback that reveals items on scroll
    let ticking = false;
    
    const checkScroll = () => {
      this.items.forEach(item => {
        if (!item.classList.contains('revealed')) {
          const rect = item.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight * 0.9; // Trigger when 90% of viewport shows element
          
          if (isVisible) {
            this.revealItem(item);
          }
        }
      });
      
      ticking = false;
    };
    
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(checkScroll);
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Check initial state
    checkScroll();
  }
  
  // Method to manually trigger reveal (useful for testing)
  revealAll() {
    this.items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('revealed');
      }, index * 200);
    });
  }
  
  // Method to reset all items (useful for testing)
  resetAll() {
    this.items.forEach(item => {
      item.classList.remove('revealed');
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ScrollRevealSteps();
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ScrollRevealSteps();
  });
} else {
  new ScrollRevealSteps();
}